module.exports = __webpack_public_path__ + "img/we.681023b5.png";